import _ from 'lodash';

export const createInclusiveBound = _.memoize((minValue: number, maxValue: number) => {
  if (minValue > maxValue)
    throw Error('Unable to create inclusive bound helper: invalid boundaries.');
  return (value: number) => Math.min(maxValue, Math.max(minValue, value));
});

export const boundPercentInt = createInclusiveBound(0, 100);
